import { RouteConfig } from 'vue-router';

import { getProfileId } from '@/utils/profile';
import { systemMessageDetailsRoute } from './systemMessageRoute/details.route';
import { systemMessageListRoute } from './systemMessageRoute/list.route';

export const systemMessageContainerRoute: RouteConfig = {
  path: 'systemMessage',
  meta: {
    authorized: true,
    menu: {
      title: 'Powiadomienia',
      name: 'systemMessageList',
      icon: 'fa-bell',
      permissions: ['MESSAGE.LIST'],
      entityType: 'profile',
      entityId: getProfileId
    },
    breadcrumb: { title: 'Powiadomienia', name: 'systemMessageList' }
  },
  component: () => import(/* webpackChunkName: "RouterView" */ '@/components/appLayout/Router.vue'),
  children: [systemMessageListRoute, systemMessageDetailsRoute],
  redirect: { name: 'systemMessageList' }
};
